document.addEventListener('chartjs:init', function (event) {
    function cssVar(name) {
        return getComputedStyle(document.documentElement).getPropertyValue(name);
    }

    const Chart    = event.detail.Chart;
    const defaults = Chart.defaults;

    defaults.font.family = "'InterVariable', 'Inter Variable', 'Inter', sans-serif";

    function tailwindRgbToRgba(variable) {
        const match = cssVar(variable).match(/rgb\(([0-9]{1,3}) ([0-9]{1,3}) ([0-9]{1,3})\s*\/\s*([0-9.]+)\)/);

        if (match.length !== 5) {
            return rgb;
        }

        return `rgb(${match[1]}, ${match[2]}, ${match[3]}, ${match[4]})`;
    }

    function setColors() {
        defaults.borderColor              = tailwindRgbToRgba('--chartjs-border-color');
        defaults.elements.arc.borderColor = tailwindRgbToRgba('--chartjs-arc-border-color');
    }

    // initialize
    setColors();

    // redraw after dark mode toggle
    window.addEventListener('website:theme:change', () => {
        setColors();
        Object.values(Chart.instances).forEach(instance => instance.update());
    });
});
